export default __webpack_public_path__ + "static/media/Group 11770.aa9864a6.svg";